import request from "superagent";
import { getAuthHeader } from "src/utils/superagent";
import { FssSharedTypes } from "src/types";
import {
  ILicenseDetails,
  ICreateLicense,
  IUpdateLicense,
  IWorkerLicenseChangeLog,
  IWorkerLicensesCount,
} from "./interfaces";
import { environmentConfig } from "@src/appV2/environment";

const licenseManagerServiceUrl = environmentConfig.REACT_APP_LICENSE_MANAGER_SERVICE_URL;

export const getAgentLicenses = async (
  workerId: string,
  showAllLicenses = false,
  pagination?: { pageSize: 10; pageNumber: number }
): Promise<ILicenseDetails[]> => {
  const { pageNumber = 1, pageSize = 10 } = pagination || {};
  let url = `${licenseManagerServiceUrl}/workers/${workerId}/licenses`;
  if (showAllLicenses) {
    url = `${url}?filterCriteria=SHOW_ALL`;
  }
  const { body } = await request
    .get(url)
    .query({
      pageSize,
      skipCount: (pageNumber - 1) * pageSize,
    })
    .set(await getAuthHeader());

  return body;
};

export const addLicense = async (
  license: ICreateLicense,
  workerId: string
): Promise<ILicenseDetails> => {
  const { body } = await request
    .post(`${licenseManagerServiceUrl}/workers/${workerId}/licenses`)
    .set(await getAuthHeader())
    .send(license);

  return body;
};

export const updateLicense = async (
  license: IUpdateLicense,
  licenseId: string,
  workerId: string
): Promise<ILicenseDetails> => {
  const { body } = await request
    .patch(`${licenseManagerServiceUrl}/workers/${workerId}/licenses/${licenseId}`)
    .set(await getAuthHeader())
    .send(license);

  return body;
};

export const uploadVerificationDoc = async (
  workerId: string,
  fileType: string,
  file: File
): Promise<FssSharedTypes.FssUploadResponse> => {
  const { body } = await request
    .post(`${licenseManagerServiceUrl}/workers/${workerId}/licenses/presigned-url`)
    .set(await getAuthHeader())
    .send({ fileType });
  const { preSignedUrl, fileStorageFileKey } = body;
  await request.put(preSignedUrl).send(file);
  return { fileStorageFileKey };
};

export const getDistributionUrl = async (
  fileStorageFileKey: string,
  workerId: string
): Promise<string> => {
  const { body } = await request
    .post(`${licenseManagerServiceUrl}/workers/${workerId}/licenses/distribution-url`)
    .set(await getAuthHeader())
    .send({ fileStorageFileKey });
  const { distributionUrl } = body;
  return distributionUrl;
};

export const getWorkerLicenseChangeLogs = async (
  workerId: string,
  skipCount: number
): Promise<{ totalCount: number; logs: IWorkerLicenseChangeLog[] }> => {
  const { body } = await request
    .get(
      `${licenseManagerServiceUrl}/workers/${workerId}/licenses/logs?skipCount=${skipCount}&pageSize=5`
    )
    .set(await getAuthHeader());
  return body;
};

export const getWorkerLicensesCount = async (workerId: string): Promise<IWorkerLicensesCount> => {
  const { body } = await request
    .get(`${licenseManagerServiceUrl}/workers/${workerId}/licenses/count`)
    .set(await getAuthHeader());
  return body;
};
